<template>
  <div class="cont">
    <el-carousel height="220px" type="card">
      <el-carousel-item v-for="item in background" :key="item.id">
        <el-image
        style="width: 100%; height: 100% ; cursor : pointer"
        :src="item.imgPath"
        fit="contain"
        @click="bannerClick(item)"
      ></el-image>
      </el-carousel-item>
    </el-carousel>

    <div style="margin:20px 0;font-size: 18px;font-weight: 700;color: #666666;display:flex;align-items:center">
      <div style="width:227px;height:51px" :style="{backgroundImage: 'url(' + imgu105 + ')' }"></div>
      <el-autocomplete  @input="handleInput" :fetch-suggestions="querySearch"  @select="handleSelect"  v-model="query" placeholder="请输入DIXCEL产品编号" style="height:51px;line-height:51px;width:400px;height:51px;margin-left:10px"/>
      <div @click="gotoProductList" style="height:50px;width:60px;background-color:#f90000;margin-left:10px;justify-content:center;align-items:center;display:flex;cursor : pointer">
        <i class="el-icon-search" style="color:#fff;font-size:28px;"></i>
      </div>
    </div>

    <el-row :gutter="10" class="sort">
      <el-col :span="6" style="cursor : pointer">
        <router-link :to="{ name: 'FrameCode'}" tag="div">
          <div class="sort-item">
            <div>
              <el-image
                style="width: 285px; height: 250px"
                :src=" this.common.publicUrl + '/profile/avatar/u82_div.png' "
                fit="contain">
              </el-image>
            </div>
          </div>
        </router-link>


      </el-col>
      <el-col :span="6" style="cursor : pointer">
        <router-link :to="{ name: 'CarType'}" tag="div">
          <div class="sort-item">
            <div>
              <el-image
                style="width: 285px; height: 250px"
                :src=" this.common.publicUrl + '/profile/avatar/u83_div.png' "
                fit="contain">
              </el-image>
            </div>
          </div>
        </router-link>

      </el-col>
      <el-col :span="6" style="cursor : pointer">
        <router-link :to="{ name: 'BrakeOil'}" tag="div">
          <div class="sort-item">
            <div>
              <el-image
                style="width: 285px; height: 250px"
                :src=" this.common.publicUrl + '/profile/avatar/u84_div.png' "
                fit="contain">
              </el-image>
            </div>
          </div>
        </router-link>

      </el-col>
      <el-col :span="6" style="cursor : pointer">
        <router-link :to="{ name: 'ModCaliper'}" tag="div">
          <div class="sort-item">
            <div>
              <el-image
                style="width: 285px; height: 250px"
                :src=" this.common.publicUrl + '/profile/avatar/u85_div.png' "
                fit="contain">
              </el-image>
            </div>
          </div>
        </router-link>
      </el-col>
    </el-row>

    <el-dialog title="活动内容" :visible.sync="promotionVisible" width="600px" center
               :show-close='false'
               :close-on-press-escape='false'
               :close-on-click-modal	='false'
    >
      <div style="width:100%;margin-bottom:10px;text-align: center">
        <el-image  :src="imagePath" fit="contain"></el-image>
      </div>
      <div style="display:flex;justify-content:center">
        <div class="background_style btn"
             :style="{backgroundImage: 'url(' + btn_red + ')' }"
              style="cursor : pointer"
             @click="promotionCancel"
        >
          关闭
        </div>
      </div>

    </el-dialog>

  </div>
</template>

<script>
import { getBannerListReq,getPromotionReq } from "@/api/home/index";
import { getTextListReq} from "@/api/productList/productList";
export default {
  data(){
    return {
      publicUrl : this.common.publicUrl,
      promotionVisible :false,
      imagePath : null,
      btn_red : this.common.publicUrl + '/profile/avatar/u146.png' ,
      imgu105 :  this.common.publicUrl + '/profile/avatar/u105.png' ,
      imgu106 :  this.common.publicUrl + '/profile/avatar/u106.png' ,
      background : [ ] ,
      restaurants:[],
      query : '' , //查询您需要的产品
    }
  } ,
  methods:{
    handleInput(){
      // 去除所有空格
      this.query = this.query.replace(/\s+/g, '')
    },
    getTextList(){
      getTextListReq({
        searchType:3 ,
      }).then( res => {
        if (res.data.status == 0) {
          let texts = res.data.texts;
          this.restaurants = []
          for(let i =0;i<texts.length;i++){
            this.restaurants.push( {"value":texts[i].text})
          }
        } else if( res.data.status == 999 ){

        }else {
          this.$message.error(res.data.statusDesc);

        }
      })
    },
    querySearch(queryString, cb) {
      let restaurants = this.restaurants;
      let results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
      // 调用 callback 返回建议列表的数据
      cb(results);

    },
    handleSelect(){
        this.gotoProductList();
    },
    createFilter(queryString) {
      return (restaurant) => {
        return (restaurant.value.toLowerCase().indexOf("") === 0);
      };
    },

    //去产品编号页面
    gotoProductList(){
      this.$router.push({
        name: 'ProductID',
        params: {
          query: this.query
        }
      })
    },
    //获取轮播
    getBannerList(){
      getBannerListReq().then(res=>{
        if (res.data.status == 0) {
          this.background = res.data.list
        } else if( res.data.status == 999 ){

        } else {
          this.$message.error(res.data.statusDesc);
        }
      })
    },
    //点击banner事件
    bannerClick(row){
      if(row.urlType==1){
        this.$router.push({
          path: '/bannerInfo',
          query: {
            id: row.id
          }
        })
      }else if(row.urlType==2){
        window.open(row.weChatUrl, '_blank');
      }else{
        window.open(row.pcUrl, '_blank');
      }

    }
    ,promotionCancel(){
      this.promotionVisible = false;
    }
  } ,
  activated() {

  },

  created(){
    let login = this.$route.query.login
     if(login){
       getPromotionReq().then(res=>{
         if (res.data.status == 0&&res.data.imagePath!=null) {
           this.imagePath = this.common.publicUrl +res.data.imagePath
           this.promotionVisible = true
         }
       })
     }
    this.restaurants = []
    this.getBannerList()
    this.getTextList()
  }

}
</script>



<style lang="stylus" scoped>
.cont {
  width: 1200px;
  color: #000;
  margin: 0 auto;
  box-sizing: border-box;
  padding : 0px 0 20px
}
  .el-carousel__item:nth-child(2n) {
      // background-color: #99a9bf;
  }
  .el-carousel__item:nth-child(2n+1) {
      // background-color: #d3dce6;
  }

.input-with-select >>> .el-input__inner{
  border-radius: 20px 0 0 20px;
}
.input-with-select >>> .el-input-group__append{
  background-color #fff
  border-radius: 0 20px 20px 0;
}


.cont >>>  .el-input__inner{
  height 51px;
  line-height:51px;
}

.sort{

}
 .sort-item{
  background-color : #f0f0f0 ;
  display : flex ;
  flex-direction : column
  justify-content : center
  align-items : center
 }







</style>
